<template>
  <div>
    <SysBtn class="ml-3" @click="dialog_ativo = true">
      <v-icon left>$Excel</v-icon>
      Exportar
    </SysBtn>

    <SysDialog v-model="dialog_ativo" titulo="Selecione uma data" :largura="450">
      <v-select
        v-model="data_selecionada"
        label="Data da exportação"
        :items="lista_datas"
        item-text="text"
        item-value="value"
        outlined
        hide-details
        class="pb-1"
        clearable
      />

      <v-checkbox
        v-model="considerar_filtro"
        label="Considerar filtro"
      />

      <template #actions>
        <div class="d-flex align-center">
          <v-spacer />

          <v-btn :disabled="! (data_selecionada && data_selecionada.length > 0)" text color="primary" @click="exportarParaExcel">
            executar
          </v-btn>
        </div>
      </template>
    </SysDialog>
  </div>
</template>

<script>
import $axios from "@/api/api";
import SysDialog from "@/components/padraoDeLayout/SysDialog";
import store from "@/store";
import {computed, ref, watch} from "vue";
import {buscarDatasDiagnostico} from "@/api/Diagnostico/CurvasCruzadas";
import {logout} from "@/helpers";

export default {
  name: "ExportacaoParaExcel",
  components: {
    SysDialog
  },
  setup() {
    const dialog_ativo = ref(false);
    const data_selecionada = ref('');
    const lista_datas = ref([]);

    const FILTROS_STORE = computed(() => store.getters['filtrosUniversalAvancado/filtros_formatados']);

    const selecionarDataDefault = () => {
      data_selecionada.value = (lista_datas.value.length > 0) ? lista_datas.value[0].value : '';
    };

    const buscarListaDeDatasDiagnostico = () => {
      if (lista_datas.value.length > 0) return;

      store.dispatch("loading/addRequisicao",
        buscarDatasDiagnostico()
          .then(datas => {
            const callback = (value, index) => {
              if (index === 0) {
                return {value, text: `Hoje - ${value}`};
              }

              if (index === (datas.length - 1)) {
                return {value, text: `Parametrização - ${value}`};
              }

              return {value, text: value};
            };

            lista_datas.value = datas.map(callback);
            selecionarDataDefault();
          })
          .catch(logout)
      );
    };

    watch(() => dialog_ativo.value, buscarListaDeDatasDiagnostico);

    const considerar_filtro = ref(false);
    const exportarParaExcel = () => {
      const filtros = FILTROS_STORE.value;
      const comprador = store.getters['usuario/getComprador'];

      let url = 'relatorios/diagnostico/produtos/exportacao-excel?'
        + filtros.grupos.map(g => `grupos[]=${g}`).join('&')
        + `&data=${data_selecionada.value}`
        + `&idcomprador=${comprador.id ? comprador.id : 0}`;

      if (considerar_filtro.value) {
        const filtros = FILTROS_STORE.value;
        const appendArray = (key, values) => {
          if (Array.isArray(values) && values.length) {
            return values.map(v => `&${key}[]=${v}`).join('');
          }
          return '';
        };

        url += appendArray('segmentos', filtros.segmentos);
        url += appendArray('fornecedores', filtros.fornecedores);
        url += appendArray('produtos', filtros.produtos);
        url += appendArray('histogramas', filtros.histogramas);
        url += appendArray('tipos_produtos', filtros.tipos_produtos);

        url += appendArray('compradores', filtros.compradores);
        url += appendArray('linhas', filtros.linhas);
        url += appendArray('secoes', filtros.secoes);
        url += appendArray('categorias', filtros.categorias);
        url += appendArray('marcas', filtros.marcas);

        url += appendArray('status_produto', filtros.status_produto);
        url += appendArray('status_estoque', filtros.status_estoque);
        url += appendArray('pedidos_pendentes', filtros.pedidos_pendentes);

        url += appendArray('aplicacao', filtros.aplicacao);
        url += appendArray('curva_faturamento', filtros.curva_faturamento);
        url += appendArray('curva_popularidade', filtros.curva_popularidade);
        url += appendArray('curva_rentabilidade', filtros.curva_rentabilidade);

        if (filtros.fora_de_linha) url += `&fora_de_linha=${filtros.fora_de_linha}`;
        if (filtros.inativo_revenda) url += `&inativo_revenda=${filtros.inativo_revenda}`;
        if (filtros.produto_resgatado) url += `&produto_resgatado=${filtros.produto_resgatado}`;
        if (filtros.venda_futura_maior_que_saldo_estoque) url += `&venda_futura_maior_que_saldo_estoque=${filtros.venda_futura_maior_que_saldo_estoque}`;

        url += appendArray('primeira_entrada', filtros.primeira_entrada);
        url += appendArray('ultima_entrada', filtros.ultima_entrada);
        url += appendArray('idade', filtros.idade);
      }

      window.open(`${$axios.defaults.baseURL}/${url}`, "_blank");
      dialog_ativo.value = false;
      considerar_filtro.value = false;
      selecionarDataDefault();
    };

    return {
      dialog_ativo,
      data_selecionada,
      lista_datas,
      considerar_filtro,
      exportarParaExcel,
    }
  }
}
</script>

<style scoped>

</style>
